import * as React from 'react';
import Skeleton from '@mui/material/Skeleton';
import { Stack } from '@mui/material';
import { theme } from '../../../constants/theme';
import { useThemeContext } from '../../../hook/useThemeManager';

const AvatarShimmer = () => {
    const { themeStyle } = useThemeContext();
    return (
        <Stack direction="row" alignItems="center" sx={{ mb: 2 }}>
            <Skeleton
                animation="wave"
                variant="circular"
                width={50}
                height={40}
                sx={{ bgcolor: theme[themeStyle].darkGray60, mr: 1 }}
            />
            <Stack direction="column" width={'100%'}>
                <Skeleton
                    animation="wave"
                    height={20}
                    style={{ marginBottom: 2 }}
                    width={'70%'}
                    sx={{ bgcolor: theme[themeStyle].darkGray60 }}
                />
                <Skeleton animation="wave" height={20} width="40%" sx={{ bgcolor: theme[themeStyle].darkGray60 }} />
            </Stack>
        </Stack>
    );
};

export { AvatarShimmer };
